/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CompetitionType,
  CreateDropsBody,
  Drop,
  DropAggregateContentResponse,
  DropDiscordWidgetResponse,
  DropFollowResponse,
  DropGameNewsResponse,
  DropInstagramPostsResponse,
  DropKickVodsResponse,
  DropLiveStatusResponse,
  DropMemberStatusResponse,
  DropOptInBody,
  DropRosterResponse,
  DropSlugResponse,
  DropTikTokVideosResponse,
  DropTwitchClipsResponse,
  DropTwitchScheduleResponse,
  DropTwitchVodsResponse,
  DropType,
  DropXTweetsResponse,
  DropYouTubeVideosResponse,
  DropsMeOwnedResponse,
  GetDropCompetitionsResponse,
  GetDropPlayingResponse,
  GetDropsResponse,
  OfficialForResponse,
  RealmSigninBody,
  SurfaceStatus,
  SurfaceVisibility,
  Token,
  UpdateDropsIdBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CompetitionTypeFromJSON,
    CompetitionTypeToJSON,
    CreateDropsBodyFromJSON,
    CreateDropsBodyToJSON,
    DropFromJSON,
    DropToJSON,
    DropAggregateContentResponseFromJSON,
    DropAggregateContentResponseToJSON,
    DropDiscordWidgetResponseFromJSON,
    DropDiscordWidgetResponseToJSON,
    DropFollowResponseFromJSON,
    DropFollowResponseToJSON,
    DropGameNewsResponseFromJSON,
    DropGameNewsResponseToJSON,
    DropInstagramPostsResponseFromJSON,
    DropInstagramPostsResponseToJSON,
    DropKickVodsResponseFromJSON,
    DropKickVodsResponseToJSON,
    DropLiveStatusResponseFromJSON,
    DropLiveStatusResponseToJSON,
    DropMemberStatusResponseFromJSON,
    DropMemberStatusResponseToJSON,
    DropOptInBodyFromJSON,
    DropOptInBodyToJSON,
    DropRosterResponseFromJSON,
    DropRosterResponseToJSON,
    DropSlugResponseFromJSON,
    DropSlugResponseToJSON,
    DropTikTokVideosResponseFromJSON,
    DropTikTokVideosResponseToJSON,
    DropTwitchClipsResponseFromJSON,
    DropTwitchClipsResponseToJSON,
    DropTwitchScheduleResponseFromJSON,
    DropTwitchScheduleResponseToJSON,
    DropTwitchVodsResponseFromJSON,
    DropTwitchVodsResponseToJSON,
    DropTypeFromJSON,
    DropTypeToJSON,
    DropXTweetsResponseFromJSON,
    DropXTweetsResponseToJSON,
    DropYouTubeVideosResponseFromJSON,
    DropYouTubeVideosResponseToJSON,
    DropsMeOwnedResponseFromJSON,
    DropsMeOwnedResponseToJSON,
    GetDropCompetitionsResponseFromJSON,
    GetDropCompetitionsResponseToJSON,
    GetDropPlayingResponseFromJSON,
    GetDropPlayingResponseToJSON,
    GetDropsResponseFromJSON,
    GetDropsResponseToJSON,
    OfficialForResponseFromJSON,
    OfficialForResponseToJSON,
    RealmSigninBodyFromJSON,
    RealmSigninBodyToJSON,
    SurfaceStatusFromJSON,
    SurfaceStatusToJSON,
    SurfaceVisibilityFromJSON,
    SurfaceVisibilityToJSON,
    TokenFromJSON,
    TokenToJSON,
    UpdateDropsIdBodyFromJSON,
    UpdateDropsIdBodyToJSON,
} from '../models/index';

export interface CreateDropsRequest {
    createDropsBody: CreateDropsBody;
}

export interface CreateDropsSlugOptInRequest {
    slug: string;
    dropOptInBody?: DropOptInBody;
}

export interface CreateDropsSlugRealmSigninRequest {
    slug: string;
    xRealmUUID: string;
    xRealmTS: string;
    xRealmSig: string;
    realmSigninBody?: RealmSigninBody;
}

export interface DeleteDropsIdRequest {
    id: string;
}

export interface GetDropsRequest {
    dropType?: DropType;
    status?: SurfaceStatus;
    parentDropId?: string;
    gameId?: string;
    visibility?: SurfaceVisibility;
    search?: string;
    page?: number;
    pageSize?: number;
}

export interface GetDropsIdRequest {
    id: string;
}

export interface GetDropsIdSlugRequest {
    id: string;
}

export interface GetDropsSlugCompetitionsRequest {
    slug: string;
    type?: CompetitionType;
    activeOnly?: GetDropsSlugCompetitionsActiveOnlyEnum;
    limit?: number;
    offset?: number;
}

export interface GetDropsSlugMemberStatusRequest {
    slug: string;
    xRealmUUID?: string;
    xRealmTS?: string;
    xRealmSig?: string;
}

export interface GetDropsSlugSlugRequest {
    slug: string;
    preview?: GetDropsSlugSlugPreviewEnum;
    previewToken?: string;
}

export interface GetDropsSlugSlugContentAggregateContentRequest {
    slug: string;
}

export interface GetDropsSlugSlugContentDiscordWidgetRequest {
    slug: string;
}

export interface GetDropsSlugSlugContentGameNewsRequest {
    slug: string;
}

export interface GetDropsSlugSlugContentInstagramPostsRequest {
    slug: string;
}

export interface GetDropsSlugSlugContentKickVodsRequest {
    slug: string;
}

export interface GetDropsSlugSlugContentLiveStatusRequest {
    slug: string;
}

export interface GetDropsSlugSlugContentTiktokVideosRequest {
    slug: string;
}

export interface GetDropsSlugSlugContentTwitchClipsRequest {
    slug: string;
}

export interface GetDropsSlugSlugContentTwitchScheduleRequest {
    slug: string;
}

export interface GetDropsSlugSlugContentTwitchVodsRequest {
    slug: string;
}

export interface GetDropsSlugSlugContentXTweetsRequest {
    slug: string;
}

export interface GetDropsSlugSlugContentYoutubeVideosRequest {
    slug: string;
}

export interface GetDropsSlugSlugOfficialForRequest {
    slug: string;
}

export interface GetDropsSlugSlugPlayingRequest {
    slug: string;
    limit?: string;
}

export interface GetDropsSlugSlugRosterRequest {
    slug: string;
}

export interface UpdateDropsIdRequest {
    id: string;
    updateDropsIdBody: UpdateDropsIdBody;
}

/**
 * DropsApi - interface
 * 
 * @export
 * @interface DropsApiInterface
 */
export interface DropsApiInterface {
    /**
     * Create a new Drop (admin only).
     * @param {CreateDropsBody} createDropsBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    createDropsRaw(requestParameters: CreateDropsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Drop>>;

    /**
     * Create a new Drop (admin only).
     */
    createDrops(requestParameters: CreateDropsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Drop>;

    /**
     * Writes the member\'s relationship row for this Drop, stamping the door and the Drop\'s ledger owner. The same row a creator follow writes. Idempotent.
     * @summary Join the Drop\'s onboarding experience
     * @param {string} slug 
     * @param {DropOptInBody} [dropOptInBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    createDropsSlugOptInRaw(requestParameters: CreateDropsSlugOptInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropFollowResponse>>;

    /**
     * Writes the member\'s relationship row for this Drop, stamping the door and the Drop\'s ledger owner. The same row a creator follow writes. Idempotent.
     * Join the Drop\'s onboarding experience
     */
    createDropsSlugOptIn(requestParameters: CreateDropsSlugOptInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropFollowResponse>;

    /**
     * Runs the signed X-Realm handshake flow with the Drop\'s onboarding-experience email config. 401 without a valid handshake; 404 when the Drop or its experience is absent; 409 when the experience\'s identity provider is not REALM; 422 when Realm has no email on file (fall back to email + code).
     * @summary Codeless Realm sign-in for a Drop running a REALM onboarding experience
     * @param {string} slug 
     * @param {string} xRealmUUID Realm user id from the signed handoff.
     * @param {string} xRealmTS 10-digit Unix-seconds timestamp of the handoff signature.
     * @param {string} xRealmSig HMAC signature over UUID+TS.
     * @param {RealmSigninBody} [realmSigninBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    createDropsSlugRealmSigninRaw(requestParameters: CreateDropsSlugRealmSigninRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>>;

    /**
     * Runs the signed X-Realm handshake flow with the Drop\'s onboarding-experience email config. 401 without a valid handshake; 404 when the Drop or its experience is absent; 409 when the experience\'s identity provider is not REALM; 422 when Realm has no email on file (fall back to email + code).
     * Codeless Realm sign-in for a Drop running a REALM onboarding experience
     */
    createDropsSlugRealmSignin(requestParameters: CreateDropsSlugRealmSigninRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token>;

    /**
     * Delete a Drop (admin only).
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    deleteDropsIdRaw(requestParameters: DeleteDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a Drop (admin only).
     */
    deleteDropsId(requestParameters: DeleteDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Admin list of all Drops with optional filters. Public Drop discovery goes through GET /drop-in (directory).
     * @param {DropType} [dropType] 
     * @param {SurfaceStatus} [status] 
     * @param {string} [parentDropId] Only Drops whose parent is this Drop — a franchise\&#39;s own titles.
     * @param {string} [gameId] OWGame id. Only Drops linked to this game via gameRef, allowedGames, or a games entry equal to the game\&#39;s name (case-insensitive).
     * @param {SurfaceVisibility} [visibility] 
     * @param {string} [search] Case-insensitive substring match on name or slug.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsRaw(requestParameters: GetDropsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDropsResponse>>;

    /**
     * Admin list of all Drops with optional filters. Public Drop discovery goes through GET /drop-in (directory).
     */
    getDrops(requestParameters: GetDropsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDropsResponse>;

    /**
     * Admin fetch a Drop by ObjectId. Returns DRAFT and PRIVATE Drops too — public access uses GET /drops/slug/:slug.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsIdRaw(requestParameters: GetDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Drop>>;

    /**
     * Admin fetch a Drop by ObjectId. Returns DRAFT and PRIVATE Drops too — public access uses GET /drops/slug/:slug.
     */
    getDropsId(requestParameters: GetDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Drop>;

    /**
     * Resolve a Drop id to its public slug. Used to build share URLs from a competition\'s host reference.
     * @param {string} id Drop ObjectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsIdSlugRaw(requestParameters: GetDropsIdSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropSlugResponse>>;

    /**
     * Resolve a Drop id to its public slug. Used to build share URLs from a competition\'s host reference.
     */
    getDropsIdSlug(requestParameters: GetDropsIdSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropSlugResponse>;

    /**
     * Every Drop the authenticated user can act on — owned outright, or held through a Drop Portal membership.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsMeOwnedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropsMeOwnedResponse>>;

    /**
     * Every Drop the authenticated user can act on — owned outright, or held through a Drop Portal membership.
     */
    getDropsMeOwned(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropsMeOwnedResponse>;

    /**
     * Get all competitions linked to a Drop with full details. Resolves Competition umbrellas and their items.
     * @param {string} slug Drop URL slug
     * @param {CompetitionType} [type] Filter by competition type
     * @param {'true'} [activeOnly] Only return active/live competitions
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugCompetitionsRaw(requestParameters: GetDropsSlugCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDropCompetitionsResponse>>;

    /**
     * Get all competitions linked to a Drop with full details. Resolves Competition umbrellas and their items.
     */
    getDropsSlugCompetitions(requestParameters: GetDropsSlugCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDropCompetitionsResponse>;

    /**
     * Tells the login modal which fields it can hide for a returning member of this Drop\'s onboarding experience, identified via a signed partner-platform handshake. No session, no email lookup. 
     * @param {string} slug Drop slug.
     * @param {string} [xRealmUUID] Partner-issued user identifier.
     * @param {string} [xRealmTS] 
     * @param {string} [xRealmSig] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugMemberStatusRaw(requestParameters: GetDropsSlugMemberStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropMemberStatusResponse>>;

    /**
     * Tells the login modal which fields it can hide for a returning member of this Drop\'s onboarding experience, identified via a signed partner-platform handshake. No session, no email lookup. 
     */
    getDropsSlugMemberStatus(requestParameters: GetDropsSlugMemberStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropMemberStatusResponse>;

    /**
     * Get a Drop by its URL slug. Public access returns ACTIVE Drops only; admin auth + ?preview=true returns DRAFT Drops too.
     * @param {string} slug URL-friendly slug (e.g., \&quot;aydan\&quot;)
     * @param {'true'} [preview] Set to \&quot;true\&quot; with admin auth to preview DRAFT Drops
     * @param {string} [previewToken] Short-lived token from POST /admin/drops/{dropId}/preview-token. Opens a DRAFT Drop without admin auth, scoped to that Drop\&#39;s slug.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugRaw(requestParameters: GetDropsSlugSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Drop>>;

    /**
     * Get a Drop by its URL slug. Public access returns ACTIVE Drops only; admin auth + ?preview=true returns DRAFT Drops too.
     */
    getDropsSlugSlug(requestParameters: GetDropsSlugSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Drop>;

    /**
     * Cross-source unified content (Twitch + Kick + YouTube) merged by recency. Cached 10 minutes.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentAggregateContentRaw(requestParameters: GetDropsSlugSlugContentAggregateContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropAggregateContentResponse>>;

    /**
     * Cross-source unified content (Twitch + Kick + YouTube) merged by recency. Cached 10 minutes.
     */
    getDropsSlugSlugContentAggregateContent(requestParameters: GetDropsSlugSlugContentAggregateContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropAggregateContentResponse>;

    /**
     * Discord widget for the Drop\'s connected guild. Cached 5 minutes.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentDiscordWidgetRaw(requestParameters: GetDropsSlugSlugContentDiscordWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropDiscordWidgetResponse>>;

    /**
     * Discord widget for the Drop\'s connected guild. Cached 5 minutes.
     */
    getDropsSlugSlugContentDiscordWidget(requestParameters: GetDropsSlugSlugContentDiscordWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropDiscordWidgetResponse>;

    /**
     * Steam news for the title this Drop promotes. Empty when the Drop has no Steam app id — the section is then not rendered at all.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentGameNewsRaw(requestParameters: GetDropsSlugSlugContentGameNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropGameNewsResponse>>;

    /**
     * Steam news for the title this Drop promotes. Empty when the Drop has no Steam app id — the section is then not rendered at all.
     */
    getDropsSlugSlugContentGameNews(requestParameters: GetDropsSlugSlugContentGameNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropGameNewsResponse>;

    /**
     * Latest Instagram posts for the Drop\'s connected handle. Cached 1 hour.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentInstagramPostsRaw(requestParameters: GetDropsSlugSlugContentInstagramPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropInstagramPostsResponse>>;

    /**
     * Latest Instagram posts for the Drop\'s connected handle. Cached 1 hour.
     */
    getDropsSlugSlugContentInstagramPosts(requestParameters: GetDropsSlugSlugContentInstagramPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropInstagramPostsResponse>;

    /**
     * Recent Kick VODs for the Drop\'s connected Kick channel. Cached 15 minutes.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentKickVodsRaw(requestParameters: GetDropsSlugSlugContentKickVodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropKickVodsResponse>>;

    /**
     * Recent Kick VODs for the Drop\'s connected Kick channel. Cached 15 minutes.
     */
    getDropsSlugSlugContentKickVods(requestParameters: GetDropsSlugSlugContentKickVodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropKickVodsResponse>;

    /**
     * Multi-platform live status across the Drop\'s featured streams. Cached 30 seconds.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentLiveStatusRaw(requestParameters: GetDropsSlugSlugContentLiveStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropLiveStatusResponse>>;

    /**
     * Multi-platform live status across the Drop\'s featured streams. Cached 30 seconds.
     */
    getDropsSlugSlugContentLiveStatus(requestParameters: GetDropsSlugSlugContentLiveStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropLiveStatusResponse>;

    /**
     * Embeddable TikTok handle for the Drop\'s creator embed widget. Cached 1 hour.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentTiktokVideosRaw(requestParameters: GetDropsSlugSlugContentTiktokVideosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropTikTokVideosResponse>>;

    /**
     * Embeddable TikTok handle for the Drop\'s creator embed widget. Cached 1 hour.
     */
    getDropsSlugSlugContentTiktokVideos(requestParameters: GetDropsSlugSlugContentTiktokVideosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropTikTokVideosResponse>;

    /**
     * Most-watched Twitch clips for the Drop\'s connected channel. Cached 10 minutes.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentTwitchClipsRaw(requestParameters: GetDropsSlugSlugContentTwitchClipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropTwitchClipsResponse>>;

    /**
     * Most-watched Twitch clips for the Drop\'s connected channel. Cached 10 minutes.
     */
    getDropsSlugSlugContentTwitchClips(requestParameters: GetDropsSlugSlugContentTwitchClipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropTwitchClipsResponse>;

    /**
     * Upcoming Twitch schedule segments for the Drop\'s connected channel. Cached 1 hour.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentTwitchScheduleRaw(requestParameters: GetDropsSlugSlugContentTwitchScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropTwitchScheduleResponse>>;

    /**
     * Upcoming Twitch schedule segments for the Drop\'s connected channel. Cached 1 hour.
     */
    getDropsSlugSlugContentTwitchSchedule(requestParameters: GetDropsSlugSlugContentTwitchScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropTwitchScheduleResponse>;

    /**
     * Recent past broadcasts (VODs) for the Drop\'s connected Twitch channel. Cached 15 minutes.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentTwitchVodsRaw(requestParameters: GetDropsSlugSlugContentTwitchVodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropTwitchVodsResponse>>;

    /**
     * Recent past broadcasts (VODs) for the Drop\'s connected Twitch channel. Cached 15 minutes.
     */
    getDropsSlugSlugContentTwitchVods(requestParameters: GetDropsSlugSlugContentTwitchVodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropTwitchVodsResponse>;

    /**
     * Latest tweets for the Drop\'s connected X handle. Cached 30 minutes.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentXTweetsRaw(requestParameters: GetDropsSlugSlugContentXTweetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropXTweetsResponse>>;

    /**
     * Latest tweets for the Drop\'s connected X handle. Cached 30 minutes.
     */
    getDropsSlugSlugContentXTweets(requestParameters: GetDropsSlugSlugContentXTweetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropXTweetsResponse>;

    /**
     * Recent YouTube uploads for the Drop\'s connected channel. Cached 30 minutes.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugContentYoutubeVideosRaw(requestParameters: GetDropsSlugSlugContentYoutubeVideosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropYouTubeVideosResponse>>;

    /**
     * Recent YouTube uploads for the Drop\'s connected channel. Cached 30 minutes.
     */
    getDropsSlugSlugContentYoutubeVideos(requestParameters: GetDropsSlugSlugContentYoutubeVideosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropYouTubeVideosResponse>;

    /**
     * The rosters this creator\'s Drop appears on, as the Drops that own them. Only ACTIVE + PUBLIC Drops, and only where the creator\'s membership is enabled — a private orchestrator Drop or a paused membership is omitted rather than disclosed. Empty is a normal result.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugOfficialForRaw(requestParameters: GetDropsSlugSlugOfficialForRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfficialForResponse>>;

    /**
     * The rosters this creator\'s Drop appears on, as the Drops that own them. Only ACTIVE + PUBLIC Drops, and only where the creator\'s membership is enabled — a private orchestrator Drop or a paused membership is omitted rather than disclosed. Empty is a normal result.
     */
    getDropsSlugSlugOfficialFor(requestParameters: GetDropsSlugSlugOfficialForRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfficialForResponse>;

    /**
     * Creators currently live in this title\'s platform category. COVERAGE, not endorsement — distinct from the official roster.
     * @param {string} slug 
     * @param {string} [limit] Max creators to return. Default 12, capped at 48.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugPlayingRaw(requestParameters: GetDropsSlugSlugPlayingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDropPlayingResponse>>;

    /**
     * Creators currently live in this title\'s platform category. COVERAGE, not endorsement — distinct from the official roster.
     */
    getDropsSlugSlugPlaying(requestParameters: GetDropsSlugSlugPlayingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDropPlayingResponse>;

    /**
     * The creator roster for this Drop, with its live game filter and any active campaign window applied. A Drop with no roster of its own INHERITS its nearest published ancestor\'s — see inheritedFromName — and members scoped to specific titles (scopeDropIds) appear only on those. Cached 30 seconds.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    getDropsSlugSlugRosterRaw(requestParameters: GetDropsSlugSlugRosterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropRosterResponse>>;

    /**
     * The creator roster for this Drop, with its live game filter and any active campaign window applied. A Drop with no roster of its own INHERITS its nearest published ancestor\'s — see inheritedFromName — and members scoped to specific titles (scopeDropIds) appear only on those. Cached 30 seconds.
     */
    getDropsSlugSlugRoster(requestParameters: GetDropsSlugSlugRosterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropRosterResponse>;

    /**
     * Update an existing Drop (admin only). Sparse — only fields present in the body are written.
     * @param {string} id 
     * @param {UpdateDropsIdBody} updateDropsIdBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropsApiInterface
     */
    updateDropsIdRaw(requestParameters: UpdateDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Drop>>;

    /**
     * Update an existing Drop (admin only). Sparse — only fields present in the body are written.
     */
    updateDropsId(requestParameters: UpdateDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Drop>;

}

/**
 * 
 */
export class DropsApi extends runtime.BaseAPI implements DropsApiInterface {

    /**
     * Create a new Drop (admin only).
     */
    async createDropsRaw(requestParameters: CreateDropsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Drop>> {
        if (requestParameters['createDropsBody'] == null) {
            throw new runtime.RequiredError(
                'createDropsBody',
                'Required parameter "createDropsBody" was null or undefined when calling createDrops().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDropsBodyToJSON(requestParameters['createDropsBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropFromJSON(jsonValue));
    }

    /**
     * Create a new Drop (admin only).
     */
    async createDrops(requestParameters: CreateDropsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Drop> {
        const response = await this.createDropsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Writes the member\'s relationship row for this Drop, stamping the door and the Drop\'s ledger owner. The same row a creator follow writes. Idempotent.
     * Join the Drop\'s onboarding experience
     */
    async createDropsSlugOptInRaw(requestParameters: CreateDropsSlugOptInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropFollowResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createDropsSlugOptIn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops/{slug}/opt-in`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DropOptInBodyToJSON(requestParameters['dropOptInBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropFollowResponseFromJSON(jsonValue));
    }

    /**
     * Writes the member\'s relationship row for this Drop, stamping the door and the Drop\'s ledger owner. The same row a creator follow writes. Idempotent.
     * Join the Drop\'s onboarding experience
     */
    async createDropsSlugOptIn(requestParameters: CreateDropsSlugOptInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropFollowResponse> {
        const response = await this.createDropsSlugOptInRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Runs the signed X-Realm handshake flow with the Drop\'s onboarding-experience email config. 401 without a valid handshake; 404 when the Drop or its experience is absent; 409 when the experience\'s identity provider is not REALM; 422 when Realm has no email on file (fall back to email + code).
     * Codeless Realm sign-in for a Drop running a REALM onboarding experience
     */
    async createDropsSlugRealmSigninRaw(requestParameters: CreateDropsSlugRealmSigninRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createDropsSlugRealmSignin().'
            );
        }

        if (requestParameters['xRealmUUID'] == null) {
            throw new runtime.RequiredError(
                'xRealmUUID',
                'Required parameter "xRealmUUID" was null or undefined when calling createDropsSlugRealmSignin().'
            );
        }

        if (requestParameters['xRealmTS'] == null) {
            throw new runtime.RequiredError(
                'xRealmTS',
                'Required parameter "xRealmTS" was null or undefined when calling createDropsSlugRealmSignin().'
            );
        }

        if (requestParameters['xRealmSig'] == null) {
            throw new runtime.RequiredError(
                'xRealmSig',
                'Required parameter "xRealmSig" was null or undefined when calling createDropsSlugRealmSignin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRealmUUID'] != null) {
            headerParameters['X-Realm-UUID'] = String(requestParameters['xRealmUUID']);
        }

        if (requestParameters['xRealmTS'] != null) {
            headerParameters['X-Realm-TS'] = String(requestParameters['xRealmTS']);
        }

        if (requestParameters['xRealmSig'] != null) {
            headerParameters['X-Realm-Sig'] = String(requestParameters['xRealmSig']);
        }


        let urlPath = `/drops/{slug}/realm-signin`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RealmSigninBodyToJSON(requestParameters['realmSigninBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
    }

    /**
     * Runs the signed X-Realm handshake flow with the Drop\'s onboarding-experience email config. 401 without a valid handshake; 404 when the Drop or its experience is absent; 409 when the experience\'s identity provider is not REALM; 422 when Realm has no email on file (fall back to email + code).
     * Codeless Realm sign-in for a Drop running a REALM onboarding experience
     */
    async createDropsSlugRealmSignin(requestParameters: CreateDropsSlugRealmSigninRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token> {
        const response = await this.createDropsSlugRealmSigninRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a Drop (admin only).
     */
    async deleteDropsIdRaw(requestParameters: DeleteDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteDropsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a Drop (admin only).
     */
    async deleteDropsId(requestParameters: DeleteDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDropsIdRaw(requestParameters, initOverrides);
    }

    /**
     * Admin list of all Drops with optional filters. Public Drop discovery goes through GET /drop-in (directory).
     */
    async getDropsRaw(requestParameters: GetDropsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDropsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['dropType'] != null) {
            queryParameters['dropType'] = requestParameters['dropType'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['parentDropId'] != null) {
            queryParameters['parentDropId'] = requestParameters['parentDropId'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['visibility'] != null) {
            queryParameters['visibility'] = requestParameters['visibility'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDropsResponseFromJSON(jsonValue));
    }

    /**
     * Admin list of all Drops with optional filters. Public Drop discovery goes through GET /drop-in (directory).
     */
    async getDrops(requestParameters: GetDropsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDropsResponse> {
        const response = await this.getDropsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin fetch a Drop by ObjectId. Returns DRAFT and PRIVATE Drops too — public access uses GET /drops/slug/:slug.
     */
    async getDropsIdRaw(requestParameters: GetDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Drop>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getDropsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropFromJSON(jsonValue));
    }

    /**
     * Admin fetch a Drop by ObjectId. Returns DRAFT and PRIVATE Drops too — public access uses GET /drops/slug/:slug.
     */
    async getDropsId(requestParameters: GetDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Drop> {
        const response = await this.getDropsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve a Drop id to its public slug. Used to build share URLs from a competition\'s host reference.
     */
    async getDropsIdSlugRaw(requestParameters: GetDropsIdSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropSlugResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getDropsIdSlug().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/{id}/slug`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropSlugResponseFromJSON(jsonValue));
    }

    /**
     * Resolve a Drop id to its public slug. Used to build share URLs from a competition\'s host reference.
     */
    async getDropsIdSlug(requestParameters: GetDropsIdSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropSlugResponse> {
        const response = await this.getDropsIdSlugRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Every Drop the authenticated user can act on — owned outright, or held through a Drop Portal membership.
     */
    async getDropsMeOwnedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropsMeOwnedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops/me/owned`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropsMeOwnedResponseFromJSON(jsonValue));
    }

    /**
     * Every Drop the authenticated user can act on — owned outright, or held through a Drop Portal membership.
     */
    async getDropsMeOwned(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropsMeOwnedResponse> {
        const response = await this.getDropsMeOwnedRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all competitions linked to a Drop with full details. Resolves Competition umbrellas and their items.
     */
    async getDropsSlugCompetitionsRaw(requestParameters: GetDropsSlugCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDropCompetitionsResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugCompetitions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['activeOnly'] != null) {
            queryParameters['activeOnly'] = requestParameters['activeOnly'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/{slug}/competitions`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDropCompetitionsResponseFromJSON(jsonValue));
    }

    /**
     * Get all competitions linked to a Drop with full details. Resolves Competition umbrellas and their items.
     */
    async getDropsSlugCompetitions(requestParameters: GetDropsSlugCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDropCompetitionsResponse> {
        const response = await this.getDropsSlugCompetitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Tells the login modal which fields it can hide for a returning member of this Drop\'s onboarding experience, identified via a signed partner-platform handshake. No session, no email lookup. 
     */
    async getDropsSlugMemberStatusRaw(requestParameters: GetDropsSlugMemberStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropMemberStatusResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugMemberStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRealmUUID'] != null) {
            headerParameters['X-Realm-UUID'] = String(requestParameters['xRealmUUID']);
        }

        if (requestParameters['xRealmTS'] != null) {
            headerParameters['X-Realm-TS'] = String(requestParameters['xRealmTS']);
        }

        if (requestParameters['xRealmSig'] != null) {
            headerParameters['X-Realm-Sig'] = String(requestParameters['xRealmSig']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops/{slug}/member-status`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropMemberStatusResponseFromJSON(jsonValue));
    }

    /**
     * Tells the login modal which fields it can hide for a returning member of this Drop\'s onboarding experience, identified via a signed partner-platform handshake. No session, no email lookup. 
     */
    async getDropsSlugMemberStatus(requestParameters: GetDropsSlugMemberStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropMemberStatusResponse> {
        const response = await this.getDropsSlugMemberStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a Drop by its URL slug. Public access returns ACTIVE Drops only; admin auth + ?preview=true returns DRAFT Drops too.
     */
    async getDropsSlugSlugRaw(requestParameters: GetDropsSlugSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Drop>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlug().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['preview'] != null) {
            queryParameters['preview'] = requestParameters['preview'];
        }

        if (requestParameters['previewToken'] != null) {
            queryParameters['previewToken'] = requestParameters['previewToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropFromJSON(jsonValue));
    }

    /**
     * Get a Drop by its URL slug. Public access returns ACTIVE Drops only; admin auth + ?preview=true returns DRAFT Drops too.
     */
    async getDropsSlugSlug(requestParameters: GetDropsSlugSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Drop> {
        const response = await this.getDropsSlugSlugRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cross-source unified content (Twitch + Kick + YouTube) merged by recency. Cached 10 minutes.
     */
    async getDropsSlugSlugContentAggregateContentRaw(requestParameters: GetDropsSlugSlugContentAggregateContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropAggregateContentResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentAggregateContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/aggregate-content`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropAggregateContentResponseFromJSON(jsonValue));
    }

    /**
     * Cross-source unified content (Twitch + Kick + YouTube) merged by recency. Cached 10 minutes.
     */
    async getDropsSlugSlugContentAggregateContent(requestParameters: GetDropsSlugSlugContentAggregateContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropAggregateContentResponse> {
        const response = await this.getDropsSlugSlugContentAggregateContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Discord widget for the Drop\'s connected guild. Cached 5 minutes.
     */
    async getDropsSlugSlugContentDiscordWidgetRaw(requestParameters: GetDropsSlugSlugContentDiscordWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropDiscordWidgetResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentDiscordWidget().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/discord-widget`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropDiscordWidgetResponseFromJSON(jsonValue));
    }

    /**
     * Discord widget for the Drop\'s connected guild. Cached 5 minutes.
     */
    async getDropsSlugSlugContentDiscordWidget(requestParameters: GetDropsSlugSlugContentDiscordWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropDiscordWidgetResponse> {
        const response = await this.getDropsSlugSlugContentDiscordWidgetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Steam news for the title this Drop promotes. Empty when the Drop has no Steam app id — the section is then not rendered at all.
     */
    async getDropsSlugSlugContentGameNewsRaw(requestParameters: GetDropsSlugSlugContentGameNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropGameNewsResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentGameNews().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/game-news`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropGameNewsResponseFromJSON(jsonValue));
    }

    /**
     * Steam news for the title this Drop promotes. Empty when the Drop has no Steam app id — the section is then not rendered at all.
     */
    async getDropsSlugSlugContentGameNews(requestParameters: GetDropsSlugSlugContentGameNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropGameNewsResponse> {
        const response = await this.getDropsSlugSlugContentGameNewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Latest Instagram posts for the Drop\'s connected handle. Cached 1 hour.
     */
    async getDropsSlugSlugContentInstagramPostsRaw(requestParameters: GetDropsSlugSlugContentInstagramPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropInstagramPostsResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentInstagramPosts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/instagram-posts`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropInstagramPostsResponseFromJSON(jsonValue));
    }

    /**
     * Latest Instagram posts for the Drop\'s connected handle. Cached 1 hour.
     */
    async getDropsSlugSlugContentInstagramPosts(requestParameters: GetDropsSlugSlugContentInstagramPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropInstagramPostsResponse> {
        const response = await this.getDropsSlugSlugContentInstagramPostsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recent Kick VODs for the Drop\'s connected Kick channel. Cached 15 minutes.
     */
    async getDropsSlugSlugContentKickVodsRaw(requestParameters: GetDropsSlugSlugContentKickVodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropKickVodsResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentKickVods().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/kick-vods`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropKickVodsResponseFromJSON(jsonValue));
    }

    /**
     * Recent Kick VODs for the Drop\'s connected Kick channel. Cached 15 minutes.
     */
    async getDropsSlugSlugContentKickVods(requestParameters: GetDropsSlugSlugContentKickVodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropKickVodsResponse> {
        const response = await this.getDropsSlugSlugContentKickVodsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Multi-platform live status across the Drop\'s featured streams. Cached 30 seconds.
     */
    async getDropsSlugSlugContentLiveStatusRaw(requestParameters: GetDropsSlugSlugContentLiveStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropLiveStatusResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentLiveStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/live-status`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropLiveStatusResponseFromJSON(jsonValue));
    }

    /**
     * Multi-platform live status across the Drop\'s featured streams. Cached 30 seconds.
     */
    async getDropsSlugSlugContentLiveStatus(requestParameters: GetDropsSlugSlugContentLiveStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropLiveStatusResponse> {
        const response = await this.getDropsSlugSlugContentLiveStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Embeddable TikTok handle for the Drop\'s creator embed widget. Cached 1 hour.
     */
    async getDropsSlugSlugContentTiktokVideosRaw(requestParameters: GetDropsSlugSlugContentTiktokVideosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropTikTokVideosResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentTiktokVideos().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/tiktok-videos`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropTikTokVideosResponseFromJSON(jsonValue));
    }

    /**
     * Embeddable TikTok handle for the Drop\'s creator embed widget. Cached 1 hour.
     */
    async getDropsSlugSlugContentTiktokVideos(requestParameters: GetDropsSlugSlugContentTiktokVideosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropTikTokVideosResponse> {
        const response = await this.getDropsSlugSlugContentTiktokVideosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Most-watched Twitch clips for the Drop\'s connected channel. Cached 10 minutes.
     */
    async getDropsSlugSlugContentTwitchClipsRaw(requestParameters: GetDropsSlugSlugContentTwitchClipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropTwitchClipsResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentTwitchClips().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/twitch-clips`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropTwitchClipsResponseFromJSON(jsonValue));
    }

    /**
     * Most-watched Twitch clips for the Drop\'s connected channel. Cached 10 minutes.
     */
    async getDropsSlugSlugContentTwitchClips(requestParameters: GetDropsSlugSlugContentTwitchClipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropTwitchClipsResponse> {
        const response = await this.getDropsSlugSlugContentTwitchClipsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upcoming Twitch schedule segments for the Drop\'s connected channel. Cached 1 hour.
     */
    async getDropsSlugSlugContentTwitchScheduleRaw(requestParameters: GetDropsSlugSlugContentTwitchScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropTwitchScheduleResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentTwitchSchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/twitch-schedule`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropTwitchScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Upcoming Twitch schedule segments for the Drop\'s connected channel. Cached 1 hour.
     */
    async getDropsSlugSlugContentTwitchSchedule(requestParameters: GetDropsSlugSlugContentTwitchScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropTwitchScheduleResponse> {
        const response = await this.getDropsSlugSlugContentTwitchScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recent past broadcasts (VODs) for the Drop\'s connected Twitch channel. Cached 15 minutes.
     */
    async getDropsSlugSlugContentTwitchVodsRaw(requestParameters: GetDropsSlugSlugContentTwitchVodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropTwitchVodsResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentTwitchVods().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/twitch-vods`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropTwitchVodsResponseFromJSON(jsonValue));
    }

    /**
     * Recent past broadcasts (VODs) for the Drop\'s connected Twitch channel. Cached 15 minutes.
     */
    async getDropsSlugSlugContentTwitchVods(requestParameters: GetDropsSlugSlugContentTwitchVodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropTwitchVodsResponse> {
        const response = await this.getDropsSlugSlugContentTwitchVodsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Latest tweets for the Drop\'s connected X handle. Cached 30 minutes.
     */
    async getDropsSlugSlugContentXTweetsRaw(requestParameters: GetDropsSlugSlugContentXTweetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropXTweetsResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentXTweets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/x-tweets`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropXTweetsResponseFromJSON(jsonValue));
    }

    /**
     * Latest tweets for the Drop\'s connected X handle. Cached 30 minutes.
     */
    async getDropsSlugSlugContentXTweets(requestParameters: GetDropsSlugSlugContentXTweetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropXTweetsResponse> {
        const response = await this.getDropsSlugSlugContentXTweetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recent YouTube uploads for the Drop\'s connected channel. Cached 30 minutes.
     */
    async getDropsSlugSlugContentYoutubeVideosRaw(requestParameters: GetDropsSlugSlugContentYoutubeVideosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropYouTubeVideosResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugContentYoutubeVideos().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/content/youtube-videos`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropYouTubeVideosResponseFromJSON(jsonValue));
    }

    /**
     * Recent YouTube uploads for the Drop\'s connected channel. Cached 30 minutes.
     */
    async getDropsSlugSlugContentYoutubeVideos(requestParameters: GetDropsSlugSlugContentYoutubeVideosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropYouTubeVideosResponse> {
        const response = await this.getDropsSlugSlugContentYoutubeVideosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The rosters this creator\'s Drop appears on, as the Drops that own them. Only ACTIVE + PUBLIC Drops, and only where the creator\'s membership is enabled — a private orchestrator Drop or a paused membership is omitted rather than disclosed. Empty is a normal result.
     */
    async getDropsSlugSlugOfficialForRaw(requestParameters: GetDropsSlugSlugOfficialForRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfficialForResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugOfficialFor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/official-for`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OfficialForResponseFromJSON(jsonValue));
    }

    /**
     * The rosters this creator\'s Drop appears on, as the Drops that own them. Only ACTIVE + PUBLIC Drops, and only where the creator\'s membership is enabled — a private orchestrator Drop or a paused membership is omitted rather than disclosed. Empty is a normal result.
     */
    async getDropsSlugSlugOfficialFor(requestParameters: GetDropsSlugSlugOfficialForRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfficialForResponse> {
        const response = await this.getDropsSlugSlugOfficialForRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creators currently live in this title\'s platform category. COVERAGE, not endorsement — distinct from the official roster.
     */
    async getDropsSlugSlugPlayingRaw(requestParameters: GetDropsSlugSlugPlayingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDropPlayingResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugPlaying().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/playing`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDropPlayingResponseFromJSON(jsonValue));
    }

    /**
     * Creators currently live in this title\'s platform category. COVERAGE, not endorsement — distinct from the official roster.
     */
    async getDropsSlugSlugPlaying(requestParameters: GetDropsSlugSlugPlayingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDropPlayingResponse> {
        const response = await this.getDropsSlugSlugPlayingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The creator roster for this Drop, with its live game filter and any active campaign window applied. A Drop with no roster of its own INHERITS its nearest published ancestor\'s — see inheritedFromName — and members scoped to specific titles (scopeDropIds) appear only on those. Cached 30 seconds.
     */
    async getDropsSlugSlugRosterRaw(requestParameters: GetDropsSlugSlugRosterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropRosterResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugSlugRoster().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/slug/{slug}/roster`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropRosterResponseFromJSON(jsonValue));
    }

    /**
     * The creator roster for this Drop, with its live game filter and any active campaign window applied. A Drop with no roster of its own INHERITS its nearest published ancestor\'s — see inheritedFromName — and members scoped to specific titles (scopeDropIds) appear only on those. Cached 30 seconds.
     */
    async getDropsSlugSlugRoster(requestParameters: GetDropsSlugSlugRosterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropRosterResponse> {
        const response = await this.getDropsSlugSlugRosterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing Drop (admin only). Sparse — only fields present in the body are written.
     */
    async updateDropsIdRaw(requestParameters: UpdateDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Drop>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateDropsId().'
            );
        }

        if (requestParameters['updateDropsIdBody'] == null) {
            throw new runtime.RequiredError(
                'updateDropsIdBody',
                'Required parameter "updateDropsIdBody" was null or undefined when calling updateDropsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDropsIdBodyToJSON(requestParameters['updateDropsIdBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropFromJSON(jsonValue));
    }

    /**
     * Update an existing Drop (admin only). Sparse — only fields present in the body are written.
     */
    async updateDropsId(requestParameters: UpdateDropsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Drop> {
        const response = await this.updateDropsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetDropsSlugCompetitionsActiveOnlyEnum = {
    True: 'true'
} as const;
export type GetDropsSlugCompetitionsActiveOnlyEnum = typeof GetDropsSlugCompetitionsActiveOnlyEnum[keyof typeof GetDropsSlugCompetitionsActiveOnlyEnum];
/**
 * @export
 */
export const GetDropsSlugSlugPreviewEnum = {
    True: 'true'
} as const;
export type GetDropsSlugSlugPreviewEnum = typeof GetDropsSlugSlugPreviewEnum[keyof typeof GetDropsSlugSlugPreviewEnum];
